import { TreinserieDto } from "@/shared/types";

export type Treinserie = {
    id: number;
    treinNummerVan: string;
    treinNummerTot: string;
    lijnnummer: string | undefined;
    bedrijf: string;
    treinType: string;
    isHandmatigToegevoegd: boolean;
    isActief: boolean;
    laatstBijgewerkt: Date;
};

export const Treinserie = {
    sort: (a: Treinserie, b: Treinserie): number => parseInt(a.treinNummerVan) - parseInt(b.treinNummerVan),
    fromDto(dto: TreinserieDto): Treinserie {
        return {
            id: dto.vanTreinNummer,
            treinNummerVan: dto.vanTreinNummer.toString(),
            treinNummerTot: dto.totEnMetTreinNummer.toString(),
            lijnnummer: dto.lijnNummer,
            bedrijf: dto.vervoerderCode.toString(),
            treinType: dto.treinSoort.code,
            isHandmatigToegevoegd: false,
            isActief: true,
            laatstBijgewerkt: new Date(),
        };
    },
};
